/* VividMD body scripts — ported from Amarenia (sticky CTA, timeline rail, results counters) */
(function () {
    var sticky = document.getElementById("hh-sticky");
    var btn = document.getElementById("hh-sticky-btn");
    if (!sticky || !btn) return;

    /* Move to <body> so position:fixed is viewport-relative and not clipped. */
    if (sticky.parentNode !== document.body) document.body.appendChild(sticky);

    /* ---------- CONFIG ---------- */
    var HEADER_OFFSET = 20;   /* px gap above the target when scrolled to (raise if you have a sticky header) */

    var ATC_SELECTORS = [
      'form[action*="/cart/add"] [name="add"]',
      'button[name="add"]',
      '.product-form__submit',
      '.product-form__buttons button[type="submit"]',
      '.add-to-cart',
      '[data-add-to-cart]',
      '.nc-atc'
    ];

    /* Scroll target: the Product Benefits block. */
    var TARGET_SELECTORS = [ '.vmd-offers', '.nc-offs' ];

    function isVisible(el) {
      if (!el) return false;
      if (el.offsetParent === null && getComputedStyle(el).position !== "fixed") return false;
      var r = el.getBoundingClientRect();
      return (r.width > 0 && r.height > 0);
    }
    function findFirst(selectors) {
      for (var i = 0; i < selectors.length; i++) {
        var nodes = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j++) {
          if (isVisible(nodes[j])) return nodes[j];
        }
      }
      return null;
    }

    /* ---- click: scroll UP to the Product Benefits block ---- */
    btn.addEventListener("click", function () {
      var target = findFirst(TARGET_SELECTORS);
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    });

    /* ---- visibility: show once Add-to-Cart has scrolled above the viewport ---- */
    var atc = findFirst(ATC_SELECTORS);
    var ticking = false;

    function evaluate() {
      ticking = false;
      var show;
      if (atc) {
        show = atc.getBoundingClientRect().bottom <= 0;
      } else {
        show = window.pageYOffset > (window.innerHeight * 0.7);
      }
      sticky.classList.toggle("visible", show);
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(evaluate); }
    }

    window.addEventListener("load", function () { if (!atc) atc = findFirst(ATC_SELECTORS); evaluate(); });
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    evaluate();
  })();

(function () {
    var section = document.querySelector('.hh-pt');
    if (!section) return;

    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var contents = section.querySelector('.hh-pt__contents');
    var rail = section.querySelector('.hh-pt__rail');
    var fill = section.querySelector('.hh-pt__rail-fill');
    var items = [].slice.call(section.querySelectorAll('.hh-pt__item'));
    if (!contents || !rail || !fill || !items.length) return;

    var mq = window.matchMedia('(min-width: 980px)');
    section.classList.add('hh-pt--js');

    function layoutRail() {
      if (mq.matches) {
        var c = contents.getBoundingClientRect();
        var f = items[0].querySelector('.hh-pt__dot').getBoundingClientRect();
        var l = items[items.length - 1].querySelector('.hh-pt__dot').getBoundingClientRect();
        var x1 = f.left + f.width / 2 - c.left;
        var x2 = l.left + l.width / 2 - c.left;
        var y = f.top + f.height / 2 - c.top;
        rail.style.left = x1 + 'px';
        rail.style.width = (x2 - x1) + 'px';
        rail.style.top = (y - 1.5) + 'px';
        rail.style.right = 'auto';
        rail.style.bottom = 'auto';
        rail.style.height = '3px';
      } else {
        rail.style.left = rail.style.width = rail.style.top = '';
        rail.style.right = rail.style.bottom = rail.style.height = '';
      }
    }

    var ticking = false;
    function update() {
      ticking = false;
      var horizontal = mq.matches;
      var rect = contents.getBoundingClientRect();
      var railRect = rail.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var prog;

      if (horizontal) {
        // Desktop: short timeline — fill as it crosses a half-viewport band.
        var start = vh * 0.85, end = vh * 0.35;
        prog = (start - rect.top) / (start - end);
      } else {
        // Mobile: tall timeline — map the fill across its FULL height so it
        // progresses gradually the whole way through.
        var anchor = vh * 0.6;
        prog = (anchor - rect.top) / rect.height;
      }

      if (prog < 0) prog = 0;
      if (prog > 1) prog = 1;

      fill.style.transform = (horizontal ? 'scaleX(' : 'scaleY(') + prog + ')';

      for (var i = 0; i < items.length; i++) {
        var d = items[i].querySelector('.hh-pt__dot').getBoundingClientRect();
        var frac;
        if (horizontal) frac = (d.left + d.width / 2 - railRect.left) / railRect.width;
        else frac = (d.top + d.height / 2 - railRect.top) / railRect.height;
        if (frac < 0) frac = 0;
        if (frac > 1) frac = 1;
        if (prog >= frac - 0.02) items[i].classList.add('is-active');
        else items[i].classList.remove('is-active');
      }
    }

    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    function relayout() { layoutRail(); update(); }

    fill.style.transform = mq.matches ? 'scaleX(0)' : 'scaleY(0)';
    layoutRail();
    window.requestAnimationFrame(update);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', relayout);
    if (mq.addEventListener) mq.addEventListener('change', relayout);
    else if (mq.addListener) mq.addListener(relayout);
  })();

(function () {
    var section = document.querySelector('.hh-results');
    if (!section) return;

    var counters = [].slice.call(section.querySelectorAll('.hh-results__item-counter')).filter(function (c) { return parseInt(c.getAttribute('data-percentage'), 10) > 0; });
    if (!counters.length) return;

    var DURATION = 1500;
    var STAGGER = 150;

    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) return;

    counters.forEach(function (c) { c.textContent = '0%'; });

    function countUp(el, target) {
      var startTime = null;
      function step(now) {
        if (startTime === null) startTime = now;
        var t = Math.min((now - startTime) / DURATION, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(eased * target) + '%';
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = target + '%';
      }
      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          counters.forEach(function (c, i) {
            var target = parseInt(c.getAttribute('data-percentage'), 10) || 0;
            setTimeout(function () { countUp(c, target); }, i * STAGGER);
          });
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);
  })();
